import { destroy } from './utils'

export async function hideSocialPost(id) {
  const path = Routes.social_post_path(id)
  const response = await destroy(path)
  return response.data
}
